import sessionKeys from '../constants/sessionKeys'

export default () => JSON.parse(localStorage.getItem(sessionKeys.PLACI_USER_DETAILS))
